"use client"
import { generatePassword } from '@/lib/AllGlobalFunction'
import { getDeviceId, showToast } from '@/lib/GetBaseUrl'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

const FacebookLogin = ({
  fetchEmailCheck,
  handleAuthResponse,
  setModelShow
}) => {
  const dispatch = useDispatch()
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.fbAsyncInit = function () {
        FB.init({
          appId: process.env.FACEBOOK_CLIENT_ID,
          cookie: true,
          xfbml: true,
          version: 'v20.0'
        })

        FB.AppEvents.logPageView()

        FB.getLoginStatus(function (response) {
          statusChangeCallback(response)
        })
      }
      ;(function (d, s, id) {
        var js,
          fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return
        js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      })(document, 'script', 'facebook-jssdk')
    }
  }, [])

  const statusChangeCallback = (response) => {
    if (response.status === 'connected') {
      fetchUserProfile()
    }
  }

  const handleFacebookLogin = () => {
    FB.login(
      function (response) {
        statusChangeCallback(response)
      },
      { scope: 'public_profile,email' }
    )
  }

  const fetchUserProfile = () => {
    FB.api(
      '/me',
      { fields: 'id,first_name,last_name,email,picture' },
      async function (facebookRes) {
        const checkEmail = await fetchEmailCheck(facebookRes?.email)

        if (checkEmail?.data?.code === 200) {
          await handleAuthResponse({
            ...facebookRes,
            emailID: facebookRes?.email
          })
        } else if (checkEmail?.data?.code === 204) {
          const signUpData = {
            firstName: facebookRes?.first_name?.trim(),
            lastName: facebookRes?.last_name?.trim(),
            emailID: facebookRes?.email?.trim(),
            MobileNo: '',
            password: generatePassword(8),
            gender: '',
            deviceId: getDeviceId()
          }
          setModelShow({ show: true, data: signUpData })
        } else {
          showToast(dispatch, {
            data: { code: 204, message: 'Email check failed' }
          })
        }
      }
    )
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e?.preventDefault()
        handleFacebookLogin()
      }}
      class="text-white w-full justify-center bg-[#3b5998] hover:bg-[#3b5998]/90 focus:ring-4 focus:ring-[#3b5998]/50 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:focus:ring-[#3b5998]/55 mr-2 mb-2"
    >
      <svg
        class="mr-2 -ml-1 w-4 h-4"
        aria-hidden="true"
        focusable="false"
        data-prefix="fab"
        data-icon="facebook-f"
        role="img"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 320 512"
      >
        <path
          fill="currentColor"
          d="M279.1 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.4 0 225.4 0c-73.22 0-121.1 44.38-121.1 124.7v70.62H22.89V288h81.39v224h100.2V288z"
        ></path>
      </svg>
      Sign in with Facebook
    </button>
  )
}

export default FacebookLogin
